import Moment from 'moment'
import * as Redux from 'redux'
import * as App from '../../app'
import * as Form from '../../components/form'
import * as Image from '../../components/image'
import * as IsActive from '../../components/is_active'
import * as Modal from '../../components/modal'
import * as Request from '../../request'
import * as Constants from './constants'
import * as Types from './types'
import * as Utils from './utils'

export const fetchLeadPosts: IsActive.FilteredFetcher = IsActive.filteredFetchAction(
    Constants.FETCH_LEAD_POSTS,
    Constants.SERVER_RESOURCE,
  )

export const fetchLeadPostsByDate: any = IsActive.filteredDateFetchAction(
  Constants.FETCH_LEAD_POSTS,
  Constants.SERVER_RESOURCE,
)

export type ResetModal = Modal.Reset
export const resetModal: ResetModal = Modal.resetModal(Constants.ADD_LEAD_POST)
export type ToggleModal = Modal.Toggle
export const closeModal: ToggleModal = Modal.closeModal(Constants.ADD_LEAD_POST)

const dateToDateString = (d: Moment.Moment): string => {
  return (d && Moment.isMoment(d)) ? d.toISOString().slice(0, 10) : null
}

const convertDates = (payload: any): any => {
  return {
    ...payload,
    end_date: dateToDateString(payload.end_date),
    start_date: dateToDateString(payload.start_date),
  }
}

export type CreatePostActionCreator = (community: App.SelectedCommunity, data: Types.LeadPost) => Redux.Action
export const create: CreatePostActionCreator  = (community, data) =>
  Request.requestActionCreator(Constants.ADD_LEAD_POST)({
    method: 'POST',
    payload: convertDates(data),
    url: `${Constants.SERVER_RESOURCE}/${community}`,
  })

export const update = (community: string, stateChange: IsActive.StateChange) =>
  Request.requestActionCreator(Constants.UPDATE_LEAD_POST)({
    method: 'PUT',
    payload: IsActive.asUpdateBody(stateChange),
    url: `${Constants.SERVER_RESOURCE}/${community}/${stateChange.id}`,
  })

export const [FormActions, FormConstants] = Form.createMaps(Constants.FEATURED_POST_FORM)

type EditModalAction = (leadPost: Types.LeadPost,  editType: string) => Form.EnterAction<Types.FormFields>
export const onEdit: EditModalAction = (leadPost: Types.LeadPost, editType: string = null) => {
  const finalLeadPost = editType === 'Edit' ? leadPost : {...leadPost, id: null}
  return FormActions[Form.ENTER](Utils.asFormFields(finalLeadPost))
}

export type OpenModalAction = () => Form.EnterAction<Types.FormFields>
export const onOpen: OpenModalAction = () => FormActions[Form.ENTER]({
  ...Constants.emptyFormField,
  [Constants.FormFieldNames.FeatureType]: Constants.FeatureTypes.Lead,
  [Constants.FormFieldNames.StartDate]: Moment().add(1, 'day'),
  [Constants.FormFieldNames.EndDate]: Moment().add(2, 'day'),
})

export const saveReorder = (community: string, leadPosts: any, selectedDate: any) => {
  return Request.requestActionCreator(Constants.SAVE_REORDERED_LEAD_POST)({
    method: 'POST',
    payload: {lead_posts: leadPosts.data},
    url: `${Constants.SERVER_RESOURCE}/${community}/reorder/${selectedDate}`,
  })
}

export const resetReorder = (community: string, leadPost: Types.LeadPost) => {
  return ({leadPost,  type: Constants.RESET_REORDERED_LEAD_POST})
}

export const uploadImage = Image.uploadImage(Constants.UPLOAD_IMAGE_LEAD_POST)



// WEBPACK FOOTER //
// ./src/pages/lead-posts/actions.ts